module.exports = __webpack_public_path__ + "img/2.4fdf81b0.png";